// daySuffix filter
//
//  Returns "February 1st", "March 2nd", etc. for a given date. You can
//  also choose to just return "1st" or "2nd" by passing false as the 2nd arg.

angular.module('app.filters').filter('daySuffix', ($filter) => {
  'ngInject';
  var suffixes = ['th', 'st', 'nd', 'rd'];
  return (input, withMonthName = true) => {
    if (!input) return '';
    var fullDate = $filter('date')(input, 'MMMM dd');
    var day = parseInt(fullDate.slice(-2));
    var relevantDigits = day < 30 ? day % 20 : day % 30;
    var suffix = relevantDigits <= 3 ? suffixes[relevantDigits] : suffixes[0];
    if (withMonthName) {
      return fullDate + suffix;
    } else {
      return day + suffix;
    }
  };
});



// WEBPACK FOOTER //
// ./app/filters/day-suffix.js